export type ImageName = keyof typeof images

export const images = {
  avatar: '/assets/images/il-avatar-white.png',
  logoAmb: '/assets/images/logo.png',
  logoNemi: '/assets/images/logo-nemi.svg',
  logoNemiRounded: '/assets/images/logo-nemi-rounded.svg',
  logoWhite: '/assets/images/logo-white.png',
  logoNemiVerde: '/assets/images/logo-nemi-verde.svg',
  logoNemiOnlyN: '/assets/images/logo-nemi-only-n.svg',
  ambLogo: '/assets/images/amb-logo.png',
  noReservations: '/assets/images/il-no-reservations@2x.png',
  noOptions: '/assets/images/il-no-opciones@2x.png',
  ticket: '/assets/images/ticket.svg',
  price: '/assets/images/price.svg',
  plus: '/assets/images/ic-plus.png',
  plusWhite: '/assets/images/ic-plus-white.png',
  options: '/assets/images/ic-options.png',
  faceHappy: '/assets/images/ic-face-happy.png',
  star: '/assets/images/ic-star.png',
  starSelected: '/assets/images/ic-star-filled.png',
  settings: '/assets/images/ic-settings.png',
  noFavorites: '/assets/images/ic-no-favorites.png',
  back: '/assets/images/ic-back.png',
  stopDisabled: '/assets/images/ic-stop-disabled.png',
  stopDestination: '/assets/images/ic-stop-end.png',
  stopOrigin: '/assets/images/ic-stop-origin.png',
  stop: '/assets/images/ic-stop.png',
  arrowRight: '/assets/images/ic-arrow-right.svg',
  close: '/assets/images/ic-close.png',
  map: '/assets/images/ic-map.png',
  list: '/assets/images/ic-list.png',
  less: '/assets/images/ic-less.png',
  more: '/assets/images/ic-more.png',
  bus: '/assets/images/bus.svg',
  busSide: '/assets/images/bus.png',
  faceMeh: '/assets/images/ic-face-meh.png',
  faceMehLightOrange: '/assets/images/ic-face-meh-light-orange.png',
  faceHappyGreen: '/assets/images/ic-face-happy-green.png',
  faceSad: '/assets/images/ic-face-sad.png',
  faceSadOrange: '/assets/images/ic-face-sad-orange.png',
  faceDizzy: '/assets/images/ic-face-dizzy.png',
  faceDizzyPink: '/assets/images/ic-face-dizzy-pink.png',
  web: '/assets/images/il-web.png',
  phone: '/assets/images/il-phone.png',
  phoneRed: '/assets/images/il-phone-red.png',
  email: '/assets/images/il-email.png',
  galileo: '/assets/images/logo_G4M.png',
  gsa: '/assets/images/gsa_logo_negatif_CMYK_300dpi_3.png',
  pedestrian: '/assets/images/pedestrian.svg',
  info: '/assets/images/ic-info@1,5x.png',
  nemiLogo: '/assets/images/nemi-logo@1x.png',
  penaltyCero: '/assets/images/il-incidencias-0.png',
  penaltyFirst: '/assets/images/il-incidencias-1.png',
  penaltySecond: '/assets/images/il-incidencias-2.png',
  penaltyThird: '/assets/images/il-incidencias-4.png',
  bigBus: '/assets/images/il-bus.png',
  checkBoxEmpty: '/assets/images/ic-checkbox-empty.png',
  checkBoxFilled: '/assets/images/ic-checkbox-filled.png',
  checkBoxFilledRed: '/assets/images/ic-checkbox-filledred.png',
  checkboxChecked: '/assets/images/checkbox-checked.png',
  checkboxUnchecked: '/assets/images/checkbox-unchecked.png',
  myLocation: '/assets/images/ic-my-location.png',
  area: '/assets/images/il-area.png',
  clear: '/assets/images/ic-clear.png',
  lens: '/assets/images/ic-lens.png',
  check: '/assets/images/ic-check.png',
  checkLanguage: '/assets/images/ic-check-language.svg',
  checkArea: '/assets/images/ic-check-language.svg',
  down: '/assets/images/ic-arrow-down.svg',
  up: '/assets/images/ic-arrow-up.svg',
  goBack: '/assets/images/ic-arrow-back.svg',
  inStop: '/assets/images/ic-stop-origin.png',
  outStop: '/assets/images/ic-stop-end.png',
  pin: '/assets/images/il-pin.png',
  background: '/assets/images/map-background.png',
  teisa: '/assets/images/teisa.jpg',
  tpg: '/assets/images/tpg.gif',
  splash: '/assets/images/splash.png',
  link: '/assets/images/link.png',
  positive: '/assets/images/il-positive.png',
  negative: '/assets/images/il-negative.png',
  userInfo: '/assets/images/userInfo.svg',
  changePassword: '/assets/images/changePassword.svg',
  changeLanguage: '/assets/images/changeLanguage.svg',
  areaSelection: '/assets/images/areaSelection.svg',
  notificationSettings: '/assets/images/notificationSettings.svg',
  unsubscribe: '/assets/images/unsubscribe.svg',
  information: '/assets/images/information.svg',
  ca: '/assets/images/language_ca.svg',
  es: '/assets/images/language_es.svg',
  en: '/assets/images/language_en.svg',
  it: '/assets/images/language_it.svg',
  fr: '/assets/images/language_fr.svg',
  webPage: '/assets/images/world.svg',
  phoneInfo: '/assets/images/phone.svg',
  emailInfo: '/assets/images/email.svg',
  filter: '/assets/images/filter.svg',
  cross: '/assets/images/ic-cross.png',
  qrCode: '/assets/images/qr.svg',
  paymentMethod: '/assets/images/ic-genericcard.png',
  password_visibility: './assets/images/eye_icon.svg',
  password_no_visibility: './assets/images/eye_crossed_icon.svg',
  realTime: '/assets/images/realTime.svg',
  clock: '/assets/images/clock.svg',
  menuBurger: '/assets/images/menu-burger.svg',
  directionArrow: '/assets/images/direction-arrow.svg',
  seat: '/assets/images/user.svg',
  prmSeat: '/assets/images/prm.svg',
  alteration: '/assets/images/alteration.svg',
  calendar: '/assets/images/calendar.svg',
  signpost: '/assets/images/signpost.svg',
  arrowLeft: '/assets/images/arrow-left.svg',
}
